import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates, saveStates, states } from '@/constants/lifecycle';
import ToggleRow from '@/components/table/ToggleRow';
import { entityVisibility } from '@/constants/states';
import { datasetSettingsFields } from '../state/state';
import { datasetManagePermissions } from '../../sharing/constants';
import { toggleDatasetSetting } from '../actions';

const DatasetSubscriptionSettingRows = ({
  allowSubscriptions,
  category,
  code,
  disabled,
  name,
  toggleSetting,
}) => (
  <ToggleRow
    context="dataset.setting"
    label="allow_private_cohorts"
    icons={['eye']}
    message="dataset.settings.subscriptions.allow"
    checked={allowSubscriptions}
    onClick={() => toggleSetting(category, code, 'allow_dataset_update_subscriptions', name)}
    disabled={disabled}
    entity="notifications"
    labelWidth={14}
  />
);

export const mapStateToProps = ({
  datasetSettings: { settings },
  datasetUsers: { permissions },
}, { category, code }) => {
  const perms = findResult(permissions, category, code) || { ...readStates };
  const item = findResult(settings, category, code)
      || {
        ...datasetSettingsFields(),
        ...saveStates,
        visibility: entityVisibility.PRIVATE,
        catalogue_definition_code: '',
      };

  return ({
    allowSubscriptions: item.allow_dataset_update_subscriptions,
    canChangeSettings: item.saveStatus !== states.PENDING && perms[datasetManagePermissions.SETTINGS],
    readStatus: item?.readStatus || states.NONE,
  });
};

export const mapDispatchToProps = {
  toggleSetting: toggleDatasetSetting,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetSubscriptionSettingRows);
